import {Fragment} from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel
} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {ICustomerGuid} from '@mybake/ui/models/Customers/ICustomerGuid';
import {CustomerCard} from './CustomerCard';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {ROWS_PER_PAGE_OPTIONS} from '../../../hooks/usePageLimit';

interface Props {
    data: ICustomerGuid[];
    totalCount: number;
    pageSize: number;
    currentPage: number;
    descending: boolean;
    orderByName: boolean;
    orderByOrdersQty: boolean;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
    onSortRequest: (id: 'name', direction: 'asc' | 'desc') => void;
}

export const CustomerTable = ({
                                  data, totalCount, pageSize, currentPage, descending, orderByName, orderByOrdersQty,
                                  onPageChange, onPageSizeChange, onSortRequest,
                              }: Props) => {
    const {t} = useAppTranslation();
    const navigate = useNavigate();
    const activeId = orderByName ? 'name' : orderByOrdersQty ? 'orders' : '';
    const order = descending ? 'desc' : 'asc';
    const columns: Array<{ id: 'name'; label: string; align: 'left' | 'right' }> = [
        {id: 'name', label: t('customers:customer_name'), align: 'left'},
        // {id: 'orders', label: t('customers:customer_qty'), align: 'right'},
    ];

    const handleSort = (id: 'name') => {
        onSortRequest(id, activeId === id && descending ? 'asc' : 'desc');
    };

    return (
        <Fragment>
            <TableContainer>
                <Table sx={{minWidth: 650}}>
                    <TableHead sx={{bgcolor: '#f5f5f5'}}>
                        <TableRow>
                            {columns.map((column) => {
                                const active = activeId === column.id;
                                return (
                                    <TableCell key={column.id} align={column.align}
                                               sortDirection={active ? order : false}>
                                        <TableSortLabel
                                            active={active}
                                            direction={active ? order : 'asc'}
                                            onClick={() => handleSort(column.id)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.length ? data.map((row) => (
                            <TableRow
                                key={row.id}
                                hover
                                sx={{cursor: 'pointer'}}
                                onClick={() => navigate(`${row.id}`)}
                            >
                                <CustomerCard row={row}/>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={columns.length} align="center" sx={{py: 3}}>
                                    {t('common:no_records_found')}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS as unknown as number[]}
                component="div"
                count={totalCount}
                rowsPerPage={pageSize}
                page={currentPage}
                onPageChange={(_, page) => onPageChange(page)}
                onRowsPerPageChange={(event) => onPageSizeChange(parseInt(event.target.value, 10))}
            />
        </Fragment>
    );
};
